import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProfileComponent } from './profile/profile.component';
import { MsalGuard } from '@azure/msal-angular';
import { TenantChooserComponent } from './azuread/tenant-chooser/tenant-chooser.component';
import { AppComponent } from './app.component';
import { StartOnboardingComponent } from './onboarding/start-onboarding/start-onboarding.component';
import { HomeComponent } from './home/home.component';
import { RequestOnboardingComponent } from './requestonboarding/request-onboarding.component';
import { OffBoardingComponent } from './offboarding/offboarding.component';
import { CheckOffBoardingComponent } from './checkoffboarding/check-offboarding.component';
import { ProcessHistoryComponent } from './process-history/process-history.component';
import { TestfilesComponent } from './admin/testfiles/testfiles.component';


const routes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full'},
  { path: 'profile',    component: ProfileComponent, canActivate: [ MsalGuard ] },
  { path: 'tenant', component: TenantChooserComponent, canActivate: [ MsalGuard ]},
  { path: 'onboarding', component: StartOnboardingComponent, canActivate: [ MsalGuard ]},
  { path: 'requestonboarding', component: RequestOnboardingComponent, canActivate: [ MsalGuard ]},
  { path: 'offboarding', component: OffBoardingComponent, canActivate: [ MsalGuard ]},
  { path: 'offboarding/checkoffboarding', component: CheckOffBoardingComponent, canActivate: [ MsalGuard ]},
  { path: 'history', component: ProcessHistoryComponent, canActivate: [MsalGuard]},
  { path: 'admin/testfiles', component: TestfilesComponent, canActivate: [MsalGuard]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
